import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { Button } from '@shared/widgets';

export const StepThree = () => {
  const { t } = useTranslation('remember');

  return (
    <div className='flex justify-center flex-wrap mt-[117px] mb-[244px]'>
      <svg
        className={clsx('w-8', PaletteUtils.isBordierPalette ? 'text-[#dc291c]' : 'text-[#E5C496]')}
        xmlns='http://www.w3.org/2000/svg'
        width='30'
        height='21'
        viewBox='0 0 30 21'
      >
        <path fill='currentColor' fillRule='nonzero' d='M28.436 0L10.783 17.839 1.564 8.523 0 10.104 10.783 21 30 1.58z' />
      </svg>
      <p className='w-full text-lg text-center leading-[1.22] tracking-[0.3px] text-[#dadada] px-[50px] mt-4 mb-6'>{t('stepThree.description')}</p>
      <Button className='leading-[20px] h-[50px] min-w-[120px]' fullWidth caption={t('buttons.ok', { ns: 'common' })} url='/' />
    </div>
  );
};
